import { StrictMode, createRoot } from "@wordpress/element";
import ONGs from "./ONGs";

// Mount the component to the 'root' div
const root = document.getElementById('table-ongs');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <ONGs />
    </StrictMode>
  );
}